import { Navigate, useNavigate, useParams } from 'react-router-dom'

import {
  FBPageInnerTabsContainer,
  FBPageTableContainer,
} from 'components/FbUI/Page/styles'
import { UnderlineTabs } from 'components/FbUI/UnderlineTabs'
import { SalesStageTable } from 'features/settings/components/SalesStageTable'
import { DistributorTable } from 'features/settings/components/DistributorTable'
import { GPOTable } from 'features/settings/components/GPOTable'

type PlatformTab = 'sales-stages' | 'distributors' | 'gpos'

const DEFAULT_TAB: PlatformTab = 'sales-stages'

const tabs: { key: PlatformTab; title: string }[] = [
  { key: 'sales-stages', title: 'Sales Stages' },
  { key: 'distributors', title: 'Distributors' },
  { key: 'gpos', title: 'GPOs' },
]

const validTabs = new Set(tabs.map((t) => t.key))

export function PlatformSettingsPage() {
  const params = useParams()
  const navigate = useNavigate()
  const tab = (params.tab as PlatformTab) ?? DEFAULT_TAB

  if (params.tab && !validTabs.has(params.tab as PlatformTab)) {
    return <Navigate to={`/settings/platform/${DEFAULT_TAB}`} replace />
  }

  return (
    <div className="w-full h-full flex flex-col flex-1 min-h-0 bg-[#fefefe]">
      <FBPageInnerTabsContainer>
        <UnderlineTabs<PlatformTab>
          tabs={tabs}
          activeKey={tab}
          onChange={(value) => navigate(`/settings/platform/${value}`)}
          idPrefix="platform-settings"
          aria-label="Platform settings tabs"
        />
      </FBPageInnerTabsContainer>
      <FBPageTableContainer
        className="bg-[#fefefe]"
        hide={tab !== 'sales-stages'}
      >
        <SalesStageTable />
      </FBPageTableContainer>
      <FBPageTableContainer
        className="bg-[#fefefe]"
        hide={tab !== 'distributors'}
      >
        <DistributorTable />
      </FBPageTableContainer>
      <FBPageTableContainer className="bg-[#fefefe]" hide={tab !== 'gpos'}>
        <GPOTable />
      </FBPageTableContainer>
    </div>
  )
}
